import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';

const CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // eslint-disable-next-line
  useExisting: forwardRef(() => DateInputComponent),
  multi: true
};


@Component({
  moduleId: module.id,
  selector: 'date-input',
  templateUrl: 'date-input.component.html',
  styleUrls: ['date-input.component.scss'],
  providers: [CONTROL_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateInputComponent implements OnChanges, ControlValueAccessor {

  @Input() date: any;

  @Input() format: string = 'MM/DD/YYYY';

  @Input() outputFormat: string = 'YYYY-MM-DD';

  @Input() name: string;

  @Input() size: string;

  @Input() formControlName: string;

  @Input() hasError: boolean = false;

  @Input() placeholder: string = 'Select Date';

  @Input() disableSince: { year: number; month: number; day: number };

  @Input() ghostValue: string;

  @Input() openSelectorTopOfInput: boolean;

  @Output() dateChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() datepickerToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(BsDatepickerDirective, {static: false}) private dp: BsDatepickerDirective;

  bsDateValue: Date;
  maxDate: Date;
  bsConfig: Partial<BsDatepickerConfig> = {
    showWeekNumbers: false,
    containerClass: 'theme-default',
    dateInputFormat: this.format,
  };

  private onTouchedCallback: any;
  private onChangeCallback: any;

  constructor(private ref: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disableSince && changes.disableSince.currentValue) {
      const d = changes.disableSince.currentValue;
      this.maxDate = new Date(d.year, d.month - 1, d.day);
    }
    if (changes.format && changes.format.currentValue) {
      this.bsConfig = { ...this.bsConfig, dateInputFormat: changes.format.currentValue };
    }
  }

  onDateChanged(date: Date): void {
    if (!date) { return; }
    const formatted = moment(date).format(this.outputFormat);
    this.date = formatted;
    this.dateChange.emit(formatted);
    if (this.onChangeCallback) {
      this.onChangeCallback(formatted);
    }
  }

  onPickerShown(): void {
    this.datepickerToggled.emit(true);
  }

  onPickerHidden(): void {
    this.datepickerToggled.emit(false);
  }

  writeValue(value: any): void {
    // imported data may come as MM/DD/YYYY
    const m = value ? moment(value, [this.outputFormat, 'MM/DD/YYYY', 'M/D/YYYY', moment.ISO_8601], true) : null;
    this.bsDateValue = m && m.isValid() ? m.toDate() : null;
    this.ref.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  public toggleDatepicker(toggle: boolean): void {
    if (!this.dp) { return; }
    if (toggle) { this.dp.show(); } else { this.dp.hide(); }
  }
}
